// Snippet discount-pill.liquid vkládá tento script pro každý produkt,
// takže na výpisu kolekce se vykoná víckrát. Bez guardu druhé provedení
// spadne na "Identifier 'DiscountPill' has already been declared".
if (!customElements.get('discount-pill')) {
  // Pridani do kosiku spoustime programovym kliknutim na bezne tlacitko.
  // Package upsell modal poslouchá submit na dokumentu a takove kliknuti
  // nerozezna od bezneho pridani - otevrel by nabidku na 2 a 3 baleni, kterou
  // Shopify se slevovym kodem nezkombinuje. Priznakem na formulari mu dame
  // vedet, ze tohle jedno pridani ma nechat projit.
  //
  // Priznak maze az package-upsell.js ve chvili, kdy ho precte. Puvodne se
  // rusil pres setTimeout(0) a to nefungovalo: nez formular submit opravdu
  // odeslal, makrotask uz stihl probehnout a modal se otevrel.
  const SKIP_CLEANUP_MS = 2000;

  function clickAddToCart(button) {
    const form = button.form || button.closest('form');

    if (form) form.dataset.skipPackageUpsell = 'true';
    button.click();
    if (form) {
      // Zachrana pro pripad, ze k odeslani formulare vubec nedojde - jinak by
      // priznak zustal viset a snedl by i pristi nabidku.
      setTimeout(() => delete form.dataset.skipPackageUpsell, SKIP_CLEANUP_MS);
    }
  }

  class DiscountPill extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("submit", this.handleSubmit.bind(this));
    }

    async handleSubmit(event) {
      event.preventDefault();

      const form = event.target;
      const button = form.querySelector('button[type="submit"]');

      if (!button) return;

      // Get discount code from button attributes
      const discountCode = button.getAttribute("data-discount-code");

      if (!discountCode) {
        console.error("Missing discount code");
        return;
      }

      try {
        // Submit the discount form
        const formData = new FormData(form);
        const response = await fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          console.warn("Could not apply discount code automatically");
        }

        // Then trigger the regular add to cart button
        let addToCartButton = document.querySelector(
          '.product-form__submit[name="add"]'
        );
        if (!addToCartButton) {
          addToCartButton = this.closest(".product-card").querySelector(
            '.btn-quick-add[name="add"]'
          );
        }
        if (addToCartButton) {
          clickAddToCart(addToCartButton);
        } else {
          throw new Error("Add to cart button not found");
        }
      } catch (error) {
        console.error("Error applying discount:", error);

        // Still try to add to cart even if discount fails
        const addToCartButton = document.querySelector(
          '.product-form__submit[name="add"]'
        );
        if (addToCartButton) {
          clickAddToCart(addToCartButton);
        }
      }
    }
  }

  customElements.define("discount-pill", DiscountPill);
}
